var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "url(#paint0_linear_3128_138279)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "url(#paint1_linear_3128_138279)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4516 24.2763C19.152 24.1728 18.0135 23.0717 18.4523 21.844C18.8057 20.8551 19.5128 20.0772 20.7086 19.5102C22.7328 18.5466 23.2227 18.0781 23.3095 16.9878L23.3117 16.9606C23.3843 16.0475 22.6427 15.3712 21.5933 15.2877C21.449 15.2762 21.3087 15.2806 21.1737 15.2993C19.7826 15.4922 18.454 16.9443 17.054 16.8329C15.654 16.7215 14.5411 15.4344 15.2254 14.208C16.5353 11.8602 19.4198 10.8905 22.3089 11.1204C26.6565 11.4664 29.3041 13.8716 29.0319 17.2924L29.0297 17.3196C28.8735 19.2822 27.8803 20.5609 25.6996 21.5943C25.1971 21.8307 24.7211 22.0658 24.3135 22.348C23.1396 23.1607 21.8748 24.3895 20.4516 24.2763ZM20.0096 33.1187C18.415 32.9918 17.2157 31.6894 17.3372 30.163C17.4576 28.6502 18.8478 27.5539 20.4424 27.6808C22.0369 27.8077 23.2499 29.1112 23.1295 30.624C23.008 32.1504 21.6042 33.2456 20.0096 33.1187Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3128_138279",
    x1: 39.16,
    y1: 7.46261e-7,
    x2: -4.36141,
    y2: 19.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3128_138279",
    x1: 9.24,
    y1: -2.46189e-8,
    x2: 4.90789,
    y2: 42.0106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c14b039dbb3fdcc0ac4bebfd42e1541d.svg";
export { ForwardRef as ReactComponent };